import { format } from "date-fns";
import useHeader from "./hooks/useHeader";
import useOnlineStatus from "~hooks/useOnlineStatus";
import { CalendarIcon, DoubtIcon, LogoVend, SignOutIcon } from "~misc/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { initialPath } from "~misc/paths";
import { useMsal, useAccount } from "@azure/msal-react";
import useUsuario from "~/fetchs/useUsuario";
import SynchronizeButtonComponent from "~components/Synchronize/Synchronize";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";
import useModal from "~components/Modal/hooks/useModal";
import ModalAction from "~components/Modal/ModalAction";

const chaveUsuario = "usuario-cache";
const chaveVendedor = "vendedor-selecionado-id";

const HeaderInfos = () => {
  const { dateTimeLastFetch, processLastFetchTime, setDateTimeLastFetch } = useHeader();
  const isOnline = useOnlineStatus();
  const versionApp = localStorage.getItem("app_version");
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);
  const navigate = useNavigate();
  const { usuario } = useUsuario();
  const { isModalOpen, closeModal, openModal } = useModal();

  function signOutClickHandler(e) {
    e.preventDefault();

    localStorage.removeItem(chaveUsuario);
    localStorage.removeItem(chaveVendedor);

    const logoutRequest = {
      account: instance.getAccountByHomeId(account.homeAccountId),
      postLogoutRedirectUri: "/",
    };

    instance.logoutRedirect(logoutRequest);
  }

  const {  checkin } = useCheckIn();




  const location = useLocation();
  const urlRota = `/roteirizacao/${checkin?.clienteId}`;
  const pathRota = location.pathname === urlRota;
  const origin = import.meta.env.VITE_MODE == "qa" ? "bg-[#ffff00]" : "";

  const somenteReflex = usuario?.slugAcessos?.includes('acesso-somente-ao-menu-de-reflex');


  return (
    <>
      <ModalAction
        isOpen={isModalOpen}
        onClose={() => closeModal()}
        title="Deseja realmente sair?"
        sub="Ao clicar em Sim, você será desconectado e redirecionado para a página de login."
        buttonOne="Sim"
        buttonTwo="Não"
        linkOne={(e) => signOutClickHandler(e)}
        linkTwo={() => closeModal()}
      />

      <div className={`border-b-2 p-2 lg:p-4 header-infos !bg-red  ${origin}`}>
        <div className="container flex justify-between items-center">
          <div className="left">
            <Link to={initialPath}>
              <LogoVend className="flex-shrink-0 flex-grow-0 basis-full logo" />
            </Link>

            <div className="box-name ml-4">
              {usuario?.nome && usuario?.email && (
                <>
                  <p className="text-2xl font-bold mb-0 leading-none">{usuario?.nome}</p>
                  <div className="flex-col">
                    <p className="font-medium mb-0 mr-1">{usuario?.email}</p>
                    <p className="text-[14px] mb-0 mr-1">
                      Versão: <b>v{versionApp}</b>
                    </p>
                    {/* <DoubtIcon /> */}
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="right-new">
            <div className="box-button">
              <div className="flex gap-x-4 container-sincronizar">
              {isOnline && !somenteReflex && (
                <>
                  <SynchronizeButtonComponent processLastFetchTime={processLastFetchTime} setDateTimeLastFetch={setDateTimeLastFetch} />
                </>
              )}
              {!somenteReflex && (
                 <div className="box-data ml-auto bg-[#F2F2F2] py-2 px-6 rounded-full flex items-center gap-2 w-[200px]">
                <CalendarIcon />
                <p className="leading-none font-medium text-sm">
                  {dateTimeLastFetch ? format(dateTimeLastFetch, "dd/MM/yyyy - HH:mm") : " - "}
                </p>
              </div>
              )}
              </div>
              <div className="box-button">
                {isOnline && (
                  <button onClick={() => openModal()}>
                    <SignOutIcon />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {!isOnline && (
        <div className="bg-red-500 text-white text-center py-2">
          <p className="font-semibold text-white">Você está offline, as informações podem estar desatualizadas.</p>
        </div>
      )}
      {checkin && !pathRota && (
        <>
          <div className="bg-[#9ACA3C] text-white text-center py-2">
            <p className="font-semibold text-white">
              Atualmente, há uma visita ativa no seu perfil. Retorne para ela.{" "}
              <button
                className="ml-4 border-2 px-4 border-white text-white rounded-[5px] hover:bg-white hover:text-[#9ACA3C]"
                onClick={() => navigate(`/roteirizacao/${checkin.clienteId}`)}
              >
                Ver Visita
              </button>
            </p>
          </div>
        </>
      )}
    </>
  );
};

export default HeaderInfos;
